var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFLocationMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2428 11.4928L8.0605 14.675C7.92133 14.8143 7.75608 14.9248 7.57417 15.0002C7.39227 15.0756 7.19729 15.1145 7.00038 15.1145C6.80347 15.1145 6.60849 15.0756 6.42658 15.0002C6.24468 14.9248 6.07942 14.8143 5.94025 14.675L2.75725 11.4928C1.91817 10.6536 1.34675 9.58455 1.11527 8.42067C0.883782 7.25679 1.00262 6.05041 1.45676 4.95407C1.91089 3.85773 2.67993 2.92068 3.66661 2.2614C4.6533 1.60213 5.81333 1.25024 7 1.25024C8.18668 1.25024 9.3467 1.60213 10.3334 2.2614C11.3201 2.92068 12.0891 3.85773 12.5433 4.95407C12.9974 6.05041 13.1162 7.25679 12.8847 8.42067C12.6533 9.58455 12.0818 10.6536 11.2428 11.4928V11.4928Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.25C9.25 7.84674 9.01295 8.41903 8.59099 8.84099C8.16903 9.26295 7.59674 9.5 7 9.5C6.40326 9.5 5.83097 9.26295 5.40901 8.84099C4.98705 8.41903 4.75 7.84674 4.75 7.25C4.75 6.65326 4.98705 6.08097 5.40901 5.65901C5.83097 5.23705 6.40326 5 7 5C7.59674 5 8.16903 5.23705 8.59099 5.65901C9.01295 6.08097 9.25 6.65326 9.25 7.25V7.25Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFLocationMarker);
export default __webpack_public_path__ + "static/media/f_location_marker.f361d0b96122f8aeff226ef55eeadc4e.svg";
export { ForwardRef as ReactComponent };